module.exports = __webpack_public_path__ + "img/BannerUseChat.21f7748d.png";